import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DB from '../../data/mockData';

export default function BCNewModal({ show, onClose }) {
  const navigate = useNavigate();
  const [product, setProduct] = useState('Valsartan 160 mg Tablet');
  const [supplier, setSupplier] = useState('Sandoz NL');

  if (!show) return null;

  const handleGenerate = () => {
    onClose();
    navigate('/bc/editor');
  };

  return (
    <div className="modal-backdrop-fo" onClick={onClose}>
      <div className="modal-fo" onClick={e => e.stopPropagation()}>
        <button className="mcl" onClick={onClose}>✕</button>
        <div className="m-title">Generate Business Case</div>
        <div className="m-sub">Nova pulls live Farminform, CBG, NHG data and structures the BC end-to-end</div>

        <div className="row g-3 mb-3">
          <div className="col-sm-6">
            <label className="flabel">Product</label>
            <input className="finput" value={product} onChange={e => setProduct(e.target.value)} />
          </div>
          <div className="col-sm-6">
            <label className="flabel">Supplier</label>
            <select className="finput" value={supplier} onChange={e => setSupplier(e.target.value)}>
              {DB.suppliers.map(s => <option key={s.id}>{s.name}</option>)}
            </select>
          </div>
        </div>
        <div className="row g-3 mb-3">
          <div className="col-sm-6">
            <label className="flabel">Market Type</label>
            <select className="finput"><option>Tender + Non-tender</option><option>Tender only</option><option>Non-tender only</option></select>
          </div>
          <div className="col-sm-6">
            <label className="flabel">Target Market Share Y1</label>
            <input className="finput" defaultValue="12%" />
          </div>
        </div>

        <div className="p-3 rounded-2 mb-3" style={{ background: 'var(--teal3)', fontSize: 12, color: 'var(--teal)' }}>
          ✦ Nova enriches with: Farminform NL volumes · NHG position · CBG competition · Tender history · Expert input requests
        </div>

        <div className="d-flex justify-content-end gap-2 pt-3 border-top">
          <button className="btn btn-s" onClick={onClose}>Cancel</button>
          <button className="btn btn-p" onClick={handleGenerate}>Generate with Nova →</button>
        </div>
      </div>
    </div>
  );
}
